export default __webpack_public_path__ + "static/media/eachImgCross.08db0d51.svg";